<template>
  <div class="wrap" style="height: 100%;">
    <!-- <el-row type="flex" justify="center">
            <el-button
                :style="{
                    marginRight: marginRight,
                    width: width,
                    heigth: height,
                    fontSize: fontSize,
                    fontFamily: chartConfig.fontFamily,
                    color: chartConfig.color,
                    textAlign: align,
                    verticalAlign: valign,
                    letterSpacing: letterSpacing,
                    fontWeight: chartConfig.fontWeight,
                    background: chartConfig.background,
                    borderLeft: chartConfig.borderLeft,
                    borderRight: chartConfig.borderRight,
                    borderBottom: chartConfig.borderBottom,
                    borderTop: chartConfig.borderTop,
                    border: chartConfig.border,

                }"
                type="primary"
                plain
                @click="goOne"
                >一分屏</el-button
            >
            <el-button
                :style="{
                    marginRight: marginRight,
                    width: width,
                    heigth: height,
                    fontSize: fontSize,
                    fontFamily: chartConfig.fontFamily,
                    color: chartConfig.color,
                    textAlign: align,
                    verticalAlign: valign,
                    letterSpacing: letterSpacing,
                    fontWeight: chartConfig.fontWeight,
                    background: chartConfig.background,
                    borderLeft: chartConfig.borderLeft,
                    borderRight: chartConfig.borderRight,
                    borderBottom: chartConfig.borderBottom,
                    borderTop: chartConfig.borderTop,
                    border: chartConfig.border,
                }"
                type="primary"
                plain
                @click="goSix"
                >六分屏</el-button
            >
            <el-button
                :style="{
                    marginRight: marginRight,
                    width: width,
                    heigth: height,
                    fontSize: fontSize,
                    fontFamily: chartConfig.fontFamily,
                    color: chartConfig.color,
                    textAlign: align,
                    verticalAlign: valign,
                    letterSpacing: letterSpacing,
                    fontWeight: chartConfig.fontWeight,
                    background: chartConfig.background,
                    borderLeft: chartConfig.borderLeft,
                    borderRight: chartConfig.borderRight,
                    borderBottom: chartConfig.borderBottom,
                    borderTop: chartConfig.borderTop,
                    border: chartConfig.border,

                }"
                type="primary"
                plain
                @click="goTwelve"
                >十二分屏</el-button
            >
        </el-row> -->

    <el-row style="height: 100%;">
      <el-col  :style="{ padding: getPadding(),height:getRows() }" :span="getColumns()" v-for="(item, index) in listVideo" :key="index">
      <!--  <video class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9" data-setup="{autoplay:true}" controls
          :autoplay="true" :muted="true" :webkit-playsinline="true" :playsinline="true" preload="auto" type="application/x-mpegURL"
          allowsInlineMediaPlayback="YES" webview.allowsInlineMediaPlayback="YES" width="100%"
          x5-video-player-fullscreen="true">
          <source :src="item.url" type="application/x-mpegURL" />
          <p class="vjs-no-js">不支持播放</p>
        </video>
 -->
        <video  class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9" :webkit-playsinline="true"
          webview.allowsInlineMediaPlayback=YES
           x5-video-player-fullscreen="true" style="object-fit:fill;height: 100%;width: 100%;"
            :ref="getVideoId(index)" :data-info="getVideoId(index)" data-ctype="videotype">
          <source  type="application/x-mpegURL">
          <p class="vjs-no-js">不支持播放</p>
        </video>
      </el-col>
    </el-row>
  </div>
</template>
<style>
</style>
<script>
  import "video.js/dist/video-js.css";
  import videojs from "video.js";
  import "videojs-contrib-hls";
  import {
    getDataService
  } from '../../api/chart/chart/index.js'
  import fwUtil from 'framework-util'
  export default {
    props: {
      width: {
        type: String,
        default: "180px",
      },
      height: {
        type: String,
        default: "30px",
      },
      listData:{
        type:Array,
        default(){
          return []
        }
      },
      queryConfig: {
        type: Object,
        default () {
          return {
            url: null,
            params: []
          }
        }
      },
      screen: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280
          }
        }
      },
      page: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280,
          }
        }
      },
      chartConfig: {
        type: Object,
        default: function() {
          return {
            columns: 1,
            rows:1,
            padding: "10px",
            url: ''

          };
        },
      }
    },
    mounted() {
      this.getData()
    },
    data() {
      return {
        listVideo: this.listData,
        listVideoControl:[],

      };
    },
    watch: {
      queryConfig: {
        handler(newValue, oldValue) {
          this.getData()
        },
        deep: true
      },
      listData:{
        handler(newValue, oldValue) {
          this.getData()
        },
        deep: true
      },
    },
    methods: {
      mouseup2(){
        console.error(899)
      },
      playById(id,src){
        if(this.listVideoControl){
          for(let i=0;i<this.listVideoControl.length;i++){
            if(id===this.listVideoControl[i].id){
              this.playOne(src,this.listVideoControl[i].control)
            }
          }
        }
      },
      getVideoId(index){
        return 'videoRef'+index
      },
      destoryVideo(){
        for(let i=0;i<this.listVideoControl.length;i++){
          this.listVideoControl[i].control.dispose()
        }
      },
      getRows(){
        if(!this.chartConfig.rows){
          return '100%'
        }
        return (100/this.chartConfig.rows)+'%'
      },
      getColumns() {
        if (!this.chartConfig.columns) {
          return 24
        }
        return 24 / this.chartConfig.columns
      },
      getData() {
        let that = this
        //this.destoryVideo()
        this.listVideoControl=[]
        if(!this.queryConfig.url){
          if(this.listData){
            this.listVideo=this.listData
            that.$nextTick(() => {
              for(let i=0;i<this.listData.length;i++){
                this.createVideo(i,this.listData[i])
              }
            })
          }
          return;
        }

        if (this.queryConfig && this.queryConfig.url) {
          let url = this.queryConfig.url
          let params = {}
          console.info("查询参数")
          console.info(this.queryConfig.params)
          if (this.queryConfig.params) {
            for (let i = 0; i < this.queryConfig.params.length; i++) {
              if (this.queryConfig.params[i].target &&
                this.queryConfig.params[i].source) {
                let _value = fwUtil.Helper.GetQueryString(this.queryConfig.params[i].source)
                console.info("查询参数值=="+_value)
                if (_value) {
                  params[this.queryConfig.params[i].target] = _value
                }
              }
            }
          }
          getDataService(url, params).then((res) => {
            that.listVideo = res
            that.$nextTick(() => {
              for(let i=0;i<res.length;i++){
                that.createVideo(i,res[i])
              }
              })

          })

        }
      },
      playOne(src,object){
        object.src(src)
        object.load(src)
        object.play()
      },
      createVideo(index,item){
        let _id=this.getVideoId(index)
        let player = videojs(this.$refs[_id][0], {
          muted: true,
          controls: true,
          preload: 'auto',
          autoplay: true,
          playsinline: true,
          type: 'application/x-mpegURL',
          allowsInlineMediaPlayback: 'YES',
          playsinline: true
        });
        player.src(item.url)
        //that.player.load(that.chartConfig.videoSrc)
        player.play()
        this.listVideoControl.push({
          id:_id,
          control:player
        })
      },
      getPadding() {
        let _height = this.chartConfig.padding ? this.chartConfig.padding : "0"
        if (_height.toString().indexOf('px') >= 0) {
          _height = _height.toString().replace("px", "")
        }
        if (_height.toString().indexOf("%") >= 0) {
          _height = _height.toString().replace("%", "")
        }
        _height = parseInt(_height)
        let height = _height / this.page.width * this.screen.width
        return height + 'px'

      },
    },
    computed: {

    },
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/images/ManyVideoHls.vue